import { useSettingsStore } from '../store/settingsStore';

export const useShowRewards = (): boolean =>
  useSettingsStore(s => s.showRewards);

export const useShowStreaks = (): boolean =>
  useSettingsStore(s => s.showStreaks);
